// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountAndNetwork_wrapper__3aj-M","title":"AccountAndNetwork_title__2NoSD"};